import AddEditEvent from '@/pages/Dashboard/AddEditEvent'
import EventAdminAddEditEvent from '@/pages/Dashboard/EventAdminAddEditEvent'
import { isUserSuperAdmin } from '@/utils/helper'

export default function EventAddEditForm() {
  const isSuperAdmin = isUserSuperAdmin()

  return isSuperAdmin ? <AddEditEvent /> : <EventAdminAddEditEvent />
}
